import { useEffect } from "react";
import { ICatalog, IPersonalData } from "../interfaces/api/IUtilsCommons.interface";
import { useApi } from "./useApi";
import { useRedux } from "./useRedux";
import UtilsCommonsService from "../services/utilsCommons.service";

const { getParentesco } = new UtilsCommonsService();

export function useParentesco() {
  const {
    data: {
      clientPersist: { uuid },
    },
  } = useRedux();
  const {
    data: dataParentesco = [],
    error: errorParentesco,
    execute: execGetParentesco,
    isLoading: isLoadingParentesco,
  } = useApi<ICatalog[], { processId: string }>(getParentesco);

  useEffect(() => {
    return () => {
      execGetParentesco({
        processId: uuid,
      });
    };
  }, []);

  return {
    dataParentesco,
    isLoadingParentesco,
    errorParentesco,
  };
}
